var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "main-container",
      class: _vm.colorMode === "dark" ? "dark-block" : "",
    },
    [
      _c("h2", [
        _vm._v(
          "Accelerating and improving research process for Africa-focused Investors"
        ),
      ]),
      _vm._v(" "),
      _c("p", [
        _vm._v(
          "Asoko provides an on-demand suite of services to support market sizing, buy-and-build strategies, competitive analysis and exit-planning. Services include market mapping, stakeholder mapping, investor mapping and historical deal analysis"
        ),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "action-wrap" }, [
        _c(
          "a",
          {
            staticClass: "cta-button",
            class: _vm.colorMode === "light" ? "medium-button" : "",
            on: { click: _vm.openSolutions },
          },
          [_vm._v("Learn More")]
        ),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }